import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'FieldCheckbox'
export const group = ''

export default class ElFieldCheckbox extends SectionProvider {
  constructor (options = {}) {
    super('ElFieldCheckbox', options)

    this.name = name
    this.group = group
  }
}